<template>
    <div class="modal fade fill-in" id="deleteIBModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header clearfix">
                    <h4>Supprimer la relation avec l'apporteur d'affaires</h4>
                </div>
                <div class="modal-body">
                    <p style="margin-bottom: 10px;">
                        Attention, vous êtes sur le point de délier définitivement l'apporteur d'affaires <strong>{{ order.intermediary_business.name }}</strong>
                        de la commande <strong>{{ order.ihrez }}</strong>. Cela aura un impact direct dans SAP, sur le suivi de l'Apporteur d'Affaires 
                        et de ses rétrocessions.
                    </p>

                    <p>Etes-vous sûr(e) de vouloir continuer ?</p>
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-default btn-cons no-margin inline"
                            data-dismiss="modal" @click="$emit('cancel')">Annuler
                    </button>

                    <button type="button" @click="$emit('confirm')"
                            class="btn btn-primary btn-cons inline" data-dismiss="modal">Dissocier
                    </button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
    export default {
        mounted () {
            $(this.$el).modal()
        },

        beforeDestroy () {
            $(this.$el).modal('hide')
            $('body').removeClass('modal-open')
            $('.modal-backdrop').remove()
        },

        props: ['order'],
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/OrdersTabContent/DeleteIBModal.vue